import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">Prelybe</h3>
            <p className="footer-description">
              Engineering reliable digital systems for businesses, institutions, and governments.
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Prelybe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

